export default __webpack_public_path__ + "static/media/cloud-build.7d36f621.svg";